module.exports = __webpack_public_path__ + "static/media/logo3.8549861c.png";